import axios from "axios";
import { API_URL } from '../Components/config'
 
// Localhost
// let domain = "http://localhost:3001/";

// domain Linl device
let domain = API_URL

const instance = axios.create({
    // baseURL: domain + "manglacrm/api",
    baseURL: domain + "coastalschedulerioapi/api/v1/admininputscreen/",
    // withCredentials: true // send cookies with requests
});

const baseUrl = () => {
    return domain;
}

export default instance;
export {
    baseUrl
}